import {fetchDetailResult} from '@/api/api';
import {useFavoriteProductStore} from '@/store/favorite.product.store';
import {useFilters} from '@/store/filter.store';
import {useProductTableStore} from '@/store/table.store';
import type {TableHeaders} from '@/types/table';
import {getUrlQueryString} from '@/utils/url.param.utils';
import type {Product} from 'dummen-shared';
import {defineStore} from 'pinia';

interface DetailResult {
	numberOfResults: number;
	products: Array<Product>;
	tableHeaders: TableHeaders | null;
}

export const useDetails = defineStore('detailStore', {
	state: (): DetailResult => ({
		numberOfResults: 0,
		products: [],
		tableHeaders: null
	}),

	actions: {
		getQueryString(): string {
			return `${getUrlQueryString()}${useFavoriteProductStore().getFavoritesAsQueryParams()}`;
		},

		async getDetailResult(): Promise<void> {
			const tableStore = useProductTableStore();
			tableStore.setLoading(true);

			const result = await fetchDetailResult(this.getQueryString());

			if (result) {
				const filters = useFilters();
				filters.setFilters(result.filters);
				filters.setSort(result.sort);
				filters.setPagination(result.pagination);
				filters.tooltips = result.tooltips;

				this.numberOfResults = result.count;
				this.products = result.products;
				this.tableHeaders = result.tableHeaders;
			}

			tableStore.setLoading(false);
		}
	}
});
